import {
    RequestConfigFunction,
} from 'app/types/request.types'

type TransportSimulationRequests = {
    name: string,
    filterRequestAll: RequestConfigFunction,
    simulationById: RequestConfigFunction<{simulationId: number}>,
    productTypesAll: RequestConfigFunction<{simulationId: number}>,
    simulationCreate: RequestConfigFunction,
    simulationUpdate: RequestConfigFunction,
}

const transportSimulationRequests: TransportSimulationRequests = {
    name: 'TransportSimulation',
    filterRequestAll: () => {
        return {
            url: 'transportsimulation/filter-request/all',
            method: 'POST',
        }
    },
    simulationById: ({
        simulationId,
    }) => {
        return {
            url: `transportsimulation/${simulationId}`,
            method: 'GET',
        }
    },
    productTypesAll: () => {
        return {
            url: 'transportsimulation/producttype/all',
            method: 'GET',
        }
    },
    simulationCreate: () => {
        return {
            url: 'transportsimulation',
            method: 'POST',
        }
    },
    simulationUpdate: () => {
        return {
            url: 'transportsimulation',
            method: 'PUT',
        }
    },
}

export default transportSimulationRequests
